import { render, staticRenderFns } from "./card-go-block.vue?vue&type=template&id=0ad1537c&scoped=true"
import script from "./card-go-block.vue?vue&type=script&lang=js"
export * from "./card-go-block.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ad1537c",
  null
  
)

export default component.exports